import { ReactElement, useEffect, useState } from 'react';

import { Tab, Tabs } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';

import { SettingsTabRoute, tabRoutesLabel, tabRoutesMap } from '../../data';
import { a11yProps } from '../../utils';

export const EngageSettingsNavigation = (): ReactElement => {
  const navigate = useNavigate();
  const location = useLocation();
  const [value, setValue] = useState<SettingsTabRoute>('general-settings');

  const handleChange = (
    _event: React.SyntheticEvent,
    newValue: SettingsTabRoute,
  ) => {
    setValue(newValue);
    navigate(newValue);
  };

  // * Update the selected tab based on the current URL
  useEffect(() => {
    const currentSettingsPath = location.pathname.substring(
      location.pathname.lastIndexOf('/') + 1,
    );

    const currentSettingsDetails = tabRoutesMap.get(currentSettingsPath);

    if (!currentSettingsDetails) {
      setValue('general-settings');
      navigate('general-settings', { replace: true });
      return;
    }

    return setValue(currentSettingsDetails.path);
  }, [location.pathname, value, navigate]);

  return (
    <Tabs
      value={value}
      onChange={handleChange}
      aria-label="engage settings tabs"
      sx={{ borderBottom: 1, borderColor: 'divider' }}
    >
      {tabRoutesLabel.map((route, index) => (
        <Tab
          value={route.path}
          key={route.path}
          label={route.label}
          {...a11yProps(index)}
          sx={{
            marginLeft: index === 0 ? 2 : 0,
            textTransform: 'none',
            fontSize: 15,
            color: '#202227',
          }}
        />
      ))}
    </Tabs>
  );
};
